import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 107	注释
 */
export default class EventComment extends EventBase {
  /**
   * 注释的构造函数
   */
  constructor()
  constructor(param: string, indent: number)
  constructor(param?: string, indent?: number) {
    super()
    if (param !== undefined){
      this.Parameter = [param]
    } 
    if (indent !== undefined){
      this.Indent = indent
    }
  }

  /**
   * 剧情ID
   */
  Code = EventID.Comment
  /**
   * 注释内容
   */
  get Content() {
    return this.Parameter?.[0] ?? ''
  }
  set Content(value) {
    this.Parameter![0] = value
  }

  /**
   * 获取显示信息
   */
}
